module.exports = __webpack_public_path__ + "static/media/arrow-right.487c4665.svg";